import {
  CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_BEGIN,
  CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_SUCCESS,
  CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_FAILURE,
  CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function loadCustomFunctionDetail(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(args.projectId);
    const version = Number(args.version);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/custom-function/${args.customFunctionId}`,
        header,
      );

      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_SUCCESS,
              data: res.data,
            });
            // toast.success('Function Detail Loaded');
            resolve(res);
          } else {
            const errMsg = getErrorMessageFromResponse(res);
            dispatch({
              type: CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_FAILURE,
              data: { error: errMsg },
            });
            toast.error(`Failed: ${errMsg}`);
            reject(errMsg);
          }
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response || err);
          dispatch({
            type: CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_FAILURE,
            data: { error: errMsg },
          });
          toast.error(`Failed: ${errMsg}`);
          reject(errMsg);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCustomFunctionDetailError() {
  return {
    type: CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_BEGIN:
      return {
        ...state,
        loadCustomFunctionDetailPending: true,
        loadCustomFunctionDetailError: null,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_SUCCESS:
      return {
        ...state,
        loadCustomFunctionDetailPending: false,
        loadCustomFunctionDetailError: null,
        selectedCustomFunction: action.data,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_FAILURE:
      return {
        ...state,
        loadCustomFunctionDetailPending: false,
        loadCustomFunctionDetailError: action.data.error,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_DISMISS_ERROR:
      return {
        ...state,
        loadCustomFunctionDetailError: null,
      };

    default:
      return state;
  }
}
